import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, React.createElement("path", {
  d: "M0 1549.71l414.504-414.503 80.598 80.598-414.504 414.504L0 1549.71zm580.351-248.782l80.598 80.598-331.626 331.626-80.598-80.598 331.626-331.626zm-82.844 414.584l248.748-248.748 80.484 80.712-248.748 248.634-80.484-80.598zm1376.38-1601.848c1.823 3.648 180.005 372.438-176.587 729.03l-146.604 146.604-2.622 665.874-222.642 222.642-331.626-331.512-30.552-30.552-9.804-9.804-537.738-537.738-331.626-331.74 222.642-222.642 665.874-2.508L1119.32 264.6c356.478-356.478 725.268-178.296 729.03-176.472l17.1 8.436 8.436 17.1zm-439.585 1494.084l1.938-503.994-361.836 361.95 251.028 250.914 108.87-108.87zm-1189.02-971.28L496.31 887.61l361.836-361.836-503.994 1.824-108.87 108.87zm1371.42 125.628c256.956-256.956 187.986-511.176 162.564-579.69-69.084-25.992-321.366-95.304-579.348 162.792l-623.01 623.01 416.898 416.898 622.896-623.01z"
}), React.createElement("path", {
  d: "M1534.987 372.558c-51.072-1.368-131.67 12.768-213.294 94.392l-40.47 40.356 173.394 173.28 40.356-40.242c82.194-82.308 96.9-161.31 94.848-213.18l-2.166-52.554-52.668-2.052z"
}));

var IconQuizLine =
/*#__PURE__*/
function (_Component) {
  _inherits(IconQuizLine, _Component);

  function IconQuizLine() {
    _classCallCheck(this, IconQuizLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconQuizLine).apply(this, arguments));
  }

  _createClass(IconQuizLine, [{
    key: "render",
    value: function render() {
      return React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconQuiz",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconQuizLine.displayName = "IconQuizLine";
  return IconQuizLine;
}(Component);

IconQuizLine.glyphName = 'quiz';
IconQuizLine.variant = 'Line';
IconQuizLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconQuizLine;
export { IconQuizLine };